import React from 'react';
import { useParams } from 'react-router-dom';
import CustomForm from '../../../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../../config/config';
import { subscriptionStatusLabels } from '../../../../../helpers/subscriptionStatusCell';

const field = (name, label, columnSize = 3, type = 'text') => ({
    name,
    label,
    type,
    columnSize,
    validations: { required: false }
});

const section = (name, label) => [
    { name: `divider_${name}`, type: 'divider', columnSize: 12 },
    { name: `label_${name}`, type: 'label', label, value: '', columnSize: 12 }
];

function Form() {
    const { selectionProcessId, vacancyId } = useParams();

    const form = {
        labelTitleView: 'Visualização de Dados do Candidato',
        // useBasePath strips every route param from the URL, so pathView must not contain ids.
        pathView: '/psp-selectionprocesses/vacancies/candidates/view',
        urlGoBack: `/psp-selectionprocesses/${selectionProcessId}/vacancies/${vacancyId}/candidates/list`,
        endpointGetById: `${config.endpoints.backend}psp/subscriptions/getById`,
        fields: [
            { name: 'label_subscription', type: 'label', label: 'Inscrição', value: '', columnSize: 12 },
            field('subscription_number', 'Nº Inscrição'),
            {
                ...field('status', 'Status', 3, 'select'),
                options: Object.entries(subscriptionStatusLabels).map(([value, label]) => ({ label, value }))
            },
            field('subscription_date', 'Data de Inscrição'),
            field('edital_number', 'Número do Edital'),
            field('selection_process_title', 'Processo Seletivo', 6),
            field('vacancy_title', 'Vaga'),
            field('role_name', 'Função / Cargo'),

            ...section('personal', 'Dados Pessoais'),
            field('name', 'Nome', 6),
            field('social_name', 'Nome Social', 6),
            field('birth_date', 'Data de Nascimento'),
            field('gender', 'Gênero'),
            field('civil_state', 'Estado Civil'),
            field('nationality', 'Nacionalidade'),
            field('rg', 'RG'),
            field('rg_emission', 'Órgão Emissor'),
            field('rg_state', 'UF do RG'),
            field('emission_date_rg', 'Data de Emissão do RG'),

            ...section('contact', 'Contato e Endereço'),
            field('email', 'E-mail', 6),
            field('phone_contact', 'Telefone'),
            field('address_zip_code', 'CEP'),
            field('address_street', 'Logradouro', 6),
            field('address_number', 'Número'),
            field('address_complement', 'Complemento'),
            field('address_neighborhood', 'Bairro', 6),
            field('address_city', 'Cidade'),
            field('address_state', 'UF'),

            ...section('education', 'Escolaridade e Experiência'),
            field('schooling', 'Escolaridade', 12),
            field('courses', 'Cursos', 12, 'textarea'),
            field('experience', 'Experiência', 12, 'textarea'),

            ...section('conditions', 'Condições Especiais'),
            field('pcd', 'Pessoa com Deficiência', 6),
            field('special_conditions', 'Condições Especiais', 6)
        ]
    };

    return (
        <CustomFormContainer
            form={form}
            content={<CustomForm form={form} />}
        />
    );
}

export default Form;
